import {
  isFacetPageType,
  isInsuranceFacetPageType
} from '../useCases/pageTypeCheck'

export const generateCustomTitleForHero = (
  pageType,
  title,
  termTitle,
  regionalHeaderText,
  hasFacetHeader
) => {
  let titleToReturn = ''

  if (
    isFacetPageType(pageType) &&
    isInsuranceFacetPageType(pageType) &&
    termTitle
  ) {
    titleToReturn = `Best ${title} Rehabs Accepting ${termTitle}`
  }

  if (regionalHeaderText) {
    titleToReturn = regionalHeaderText
  }
  if (regionalHeaderText && hasFacetHeader && isFacetPageType(pageType)) {
    titleToReturn = `${regionalHeaderText} in ${title}`
  }
  return titleToReturn
}
